import { cn } from '@Pages/pageRuntime/lib/utils';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import * as React from 'react';

const Accordion = AccordionPrimitive.Root;

const AccordionItem = ({
  className,
  ref,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) => (
  <AccordionPrimitive.Item ref={ref} className={cn('border-b', className)} {...props} />
);
AccordionItem.displayName = 'AccordionItem';

export { Accordion, AccordionItem };
